<template>
  <v-btn
    :loading="loading"
    :disabled="disabled"
    color="primary"
    small
    @click="startInspection"
  >
    <v-icon
      v-if="getIcon"
      color="white"
    >
      {{ getIcon }}
    </v-icon>
    {{ getButtonText }}
  </v-btn>
</template>

<script>
import { GET_AI_INSPECTION_URL } from '../queries';
import { aiInspectionStatuses, aiInspectionErrorCodes } from '../options';
import { AI_INSPECTION_URL_TIME_LIMIT, executeWithTimeLimit } from '../timeLimit';

const AI_BUTTON_STATUS = {
  begin: {
    text: 'AI検査を開始',
    icon: '',
  },
  waiting: {
    text: 'AI検査処理中',
    icon: 'hourglass_top',
  },
  done: {
    text: 'AI検査済',
    icon: 'done',
  },
};

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    disabled() {
      return this.$store.state.aiInspectionButton !== 'begin';
    },
    appointmentId() {
      return parseInt(this.$route.params.id, 10) || 0;
    },
    currentButton() {
      return this.$store.state.aiInspectionButton;
    },
    getButtonText() {
      return this.currentButton ? AI_BUTTON_STATUS[this.currentButton].text : '';
    },
    getIcon() {
      return this.currentButton ? AI_BUTTON_STATUS[this.currentButton].icon : '';
    },
  },
  methods: {
    changeLoadingStatus(status) {
      this.loading = status;
      this.$store.commit('setAiInspectionLoading', status);
    },
    startInspection() {
      this.changeLoadingStatus(true);

      this.$store.commit('setAiInspectionStatus', {
        apollo: this.$apollo,
        appId: this.appointmentId,
        status: aiInspectionStatuses.AWAITING_REDIRECTION });

      const getInspectionUrl = this.$apollo.query({
        query: GET_AI_INSPECTION_URL,
        variables: {
          appointmentId: this.appointmentId,
        },
      });

      executeWithTimeLimit(getInspectionUrl, AI_INSPECTION_URL_TIME_LIMIT)
        .then(({ data }) => {
          const url = data.generateInspectionUrl.url;
          if (url) {
            window.location.href = url;
          } else {
            throw new Error('No AI inspection URL generated');
          }
        })
        .catch(() => {
          this.changeLoadingStatus(false);

          this.$store.commit('setAiInspectionStatus', {
            apollo: this.$apollo,
            appId: this.appointmentId,
            status: aiInspectionStatuses.INSPECTION_FAILED });

          this.$store.commit('setAiInspectionErrorCode', {
            apollo: this.$apollo,
            appId: this.appointmentId,
            errorCode: aiInspectionErrorCodes.URL_TIME_LIMIT });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InspectionBtn.vue